import { EmailAttachmentConfig } from "./email-attachment-config";

export class UblDossierConfig {
	CostCenter:string = "";
	IncludeSalePdf:boolean = false;
	AccountingCost:string = "";
	UblType:string = "";
	UseLedgerAccountAsInvoiceLineName:boolean = false;
	IncludeSaleSeperatelyInZip:boolean = false;
	FilterPurchasesOnVatPeriod:boolean = false;
	BookkeeperEmail:string = "";
	BookkeeperEmailPurchases:string = "";
	BookkeeperEmailArchives:string = "";
	BookkeeperEmailConfigs: { [key: string]: EmailAttachmentConfig } = {};
	PeppolBookkeeperEmail:string = "";
	PeppolBookkeeperEmailPurchases:string = "";
	PeppolSendCopyToBookkeeper:boolean = false;
	LeeggoedLedger:string = "418000";
	ClearFactsCompatibiltiy:boolean = false;
	IncludeClientsXml:boolean = false;
	DontIncludePdfInPeppolUbl:boolean = false;
	PeppolSendEnabledByDefault:boolean = false;
	UseInvoiceNumberAsPaymentReference:boolean = false;
	PeppolLayoutID:number = 0;

	PeppolNoteField:string = "";
	PeppolPoField:string = "";
	PeppolGlnEV:string = "";
	PeppolIban:string = ""
	PeppolBic:string = ""

	public constructor(data?:any){
		if (!data) return;
		this.CostCenter = data.CostCenter;
		this.IncludeSalePdf = data.IncludeSalePdf;
		this.AccountingCost = data.AccountingCost;
		this.UblType = data.UblType || "invoice";
		this.UseLedgerAccountAsInvoiceLineName = data.UseLedgerAccountAsInvoiceLineName;
		this.FilterPurchasesOnVatPeriod = data.FilterPurchasesOnVatPeriod;
		this.IncludeSaleSeperatelyInZip = data.IncludeSaleSeperatelyInZip;
		this.BookkeeperEmail = data.BookkeeperEmail;
		this.BookkeeperEmailPurchases = data.BookkeeperEmailPurchases;
		this.PeppolBookkeeperEmail = data.PeppolBookkeeperEmail;
		this.PeppolBookkeeperEmailPurchases = data.PeppolBookkeeperEmailPurchases;
		this.BookkeeperEmailArchives = data.BookkeeperEmailArchives;

		// Parse BookkeeperEmailConfigs
		if (data.BookkeeperEmailConfigs) {
			this.BookkeeperEmailConfigs = {};
			for (const key in data.BookkeeperEmailConfigs) {
				this.BookkeeperEmailConfigs[key] = new EmailAttachmentConfig(data.BookkeeperEmailConfigs[key]);
			}
		}

		this.PeppolSendCopyToBookkeeper = data.PeppolSendCopyToBookkeeper;
		this.LeeggoedLedger = data.LeeggoedLedger || "418000";
		this.ClearFactsCompatibiltiy = data.ClearFactsCompatibiltiy;
		this.IncludeClientsXml = data.IncludeClientsXml;
		this.DontIncludePdfInPeppolUbl = data.DontIncludePdfInPeppolUbl;
		this.PeppolSendEnabledByDefault = data.PeppolSendEnabledByDefault;
		this.UseInvoiceNumberAsPaymentReference = data.UseInvoiceNumberAsPaymentReference;
		this.PeppolLayoutID = data.PeppolLayoutID || 0;
		this.PeppolNoteField = data.PeppolNoteField || "";
		this.PeppolPoField = data.PeppolPoField || "";
		this.PeppolGlnEV = data.PeppolGlnEV;
		this.PeppolIban = data.PeppolIban;
		this.PeppolBic = data.PeppolBic;
	}

	public getJSON(){
		const bookkeeperEmailConfigs: { [key: string]: any } = {};
		for (const key in this.BookkeeperEmailConfigs) {
			bookkeeperEmailConfigs[key] = this.BookkeeperEmailConfigs[key].getJSON();
		}

		return {
			CostCenter: this.CostCenter,
			IncludeSalePdf: this.IncludeSalePdf,
			AccountingCost: this.AccountingCost,
			UblType: this.UblType,
			UseLedgerAccountAsInvoiceLineName: this.UseLedgerAccountAsInvoiceLineName,
			FilterPurchasesOnVatPeriod: this.FilterPurchasesOnVatPeriod,
			IncludeSaleSeperatelyInZip: this.IncludeSaleSeperatelyInZip,
			BookkeeperEmail: this.BookkeeperEmail,
			BookkeeperEmailPurchases: this.BookkeeperEmailPurchases,
			BookkeeperEmailArchives: this.BookkeeperEmailArchives,
			BookkeeperEmailConfigs: bookkeeperEmailConfigs,
			PeppolBookkeeperEmail: this.PeppolBookkeeperEmail,
			PeppolBookkeeperEmailPurchases: this.PeppolBookkeeperEmailPurchases,
			PeppolSendCopyToBookkeeper: this.PeppolSendCopyToBookkeeper,
			LeeggoedLedger: this.LeeggoedLedger,
			ClearFactsCompatibiltiy: this.ClearFactsCompatibiltiy,
			IncludeClientsXml: this.IncludeClientsXml,
			DontIncludePdfInPeppolUbl: this.DontIncludePdfInPeppolUbl,
			PeppolSendEnabledByDefault: this.PeppolSendEnabledByDefault,
			UseInvoiceNumberAsPaymentReference: this.UseInvoiceNumberAsPaymentReference,
			PeppolLayoutID: this.PeppolLayoutID,
			PeppolNoteField: this.PeppolNoteField,
			PeppolPoField: this.PeppolPoField,
			PeppolGlnEV: this.PeppolGlnEV,
			PeppolIban: this.PeppolIban.trim(),
			PeppolBic: this.PeppolBic.trim()
		};
	}

	isPeppolConfigured():boolean {
		return this.PeppolIban != "" && this.PeppolBic != "";
	}
}